import { get } from '@chilipiper/service/src/api'

const inject = (link: string, callback: () => void) => {
  get(link)
    .json<{ css: string }>()
    .then(output => {
      if (output?.css) {
        const sheet = document.createElement('style')
        sheet.innerHTML = output.css
        document.body.appendChild(sheet)
      }
      callback()
    })
    .catch(callback)
}

export const injectCss = (callback: () => void) => {
  inject('workspace-preferences/get-public-css', callback)
}

export const injectCssPublic = (domain: string, linkName: string, callback: () => void) => {
  const link = `workspace-preferences/get-public-css/${domain}/${linkName}`
  inject(link, callback)
}

export const injectCustomCss = (domain: string, routeId: string, callback: () => void) => {
  const link = `custom-css/${domain}/${routeId}`
  inject(link, callback)
}
